import { defineMessages } from 'react-intl';

export default defineMessages({
    signIn: {
        id: 'tdic.portal.access-denied.Sign in',
        defaultMessage: 'Sign in'
    },
    accessDeniedLink: {
        id: 'tdic.portal.access-denied.Sign in with a different account',
        defaultMessage: '{signIn} with a different account'
    },
    doNotHavePermission: {
        id: 'tdic.portal.access-denied.You do not have permission to access the portal !!!',
        defaultMessage: 'You do not have permission to access the portal !!!'
    },
    requestProcessing: {
        id: 'tdic.portal.access-denied.Please wait, Your request is being processed...',
        defaultMessage: 'Please wait, Your request is being processed...'
    },
    notAssociatedAuthorizedUser: {
        id: 'tdic.portal.access-denied.This login is no longer associated with an authorized user.',
        defaultMessage: 'This login is no longer associated with an authorized user.'
    },
    receivedMessageInError: {
        id: 'tdic.portal.access-denied.If you feel you have received this message in error, re-enter your email and password or contact the TDIC policyholder directly for assistance.',
        defaultMessage: 'If you feel you have received this message in error, re-enter your email and password or contact the TDIC policyholder directly for assistance.'
    }
});
